import React, { useState } from "react";
import { motion } from "framer-motion";
import InteractiveText from "../../components/common/Typography/InteractiveText";
import Heading from "../../components/common/Typography/Heading";
import {
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const faqs = [
    {
      question: "How are the cost estimates determined?",
      answer:
        "Our cost estimates are meticulously calculated based on thorough market research, industry standards, and current local pricing data. We aim to provide you with the most accurate and up-to-date information to assist in your decision-making process.",
    },
    {
      question: "Can I get an exact quote for my mixer repair from this guide?",
      answer:
        "While our guide offers estimates based on average market rates, obtaining an exact quote is best achieved by directly contacting your local business for detailed quote. Their assessment of your specific needs and circumstances will ensure the most precise estimate for your mixer repair.",
    },
    {
      question:
        "How do I know if my mixer repair falls within the low, average, or high-cost range?",
      answer:
        "The cost range provided in our guide offers a general overview of pricing levels for mixer repairs. Low-cost options typically involve basic repairs or part replacements. Average-cost services encompass standard repairs or maintenance tasks. High-cost services may include specialized repairs, premium materials, or urgent service calls.",
    },
  ];

  const toggleHandler = (index) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };

  return (
    <div className={`tp-container-main mx-auto ${PUBLIC_SECTION_GAP_CLASS}`}>
      <motion.div 
        className="w-full"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={staggerContainer}
      >
        <motion.div variants={fadeInUp} transition={{ duration: 0.6, ease: "easeOut" }}>
          <Heading variant={"h2"} className={"text-offblack"}>
            FAQs
          </Heading>
        </motion.div>
        
        <motion.div
          className={PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}
          variants={fadeInUp}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="border-t border-solid border-mediumgray"></div>
        </motion.div>

        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="border-b border-solid border-mediumgray"
              variants={fadeInUp}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <div
                className="flex items-center justify-between py-6 px-4 cursor-pointer transition-colors duration-200"
                onClick={() => toggleHandler(index)}
              >
                <InteractiveText variant={"FAQHeader"} className="text-offblack font-medium">
                  {faq.question}
                </InteractiveText>
                <i
                  className={`fi ${
                    activeIndex === index ? "fi-rs-angle-up" : "fi-rs-angle-down"
                  } text-base text-offblack transition-transform duration-300 ease-in-out`}
                />
              </div>
              
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  activeIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="pb-6 px-4">
                  <InteractiveText variant={"FAQAnswer"} className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </InteractiveText>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default FAQs;
